import { createStepRegistry } from './step-registry'
import { generalProductInformationStepImplementation } from '../steps/general-product-information'
import { generalProductInformationV2StepImplementation } from '../steps/general-product-information-v2'
import { requestHandlingStepImplementation } from '../steps/request-handling'
import { documentsAndWebpagesStepImplementation } from '../steps/documents-and-webpages'
import { concernSubstanceListsStepImplementation } from '../steps/concern-substance-lists'
import { productConcernSubstancesStepImplementation } from '../steps/product-concern-substances'
import {
    complianceInformationStepImplementation,
    complianceInformationV2StepImplementation,
} from '../steps/compliance-information'
import { otherInformationStepImplementation } from '../steps/other-information'
import { declarationApprovalStepImplementation } from '../steps/declaration-approval'
import { similarReplyRequestsStepImplementation } from '../steps/similar-reply-requests'
import { sendReplyStepImplementation } from '../steps/send-reply'
import { reviewAndSubmitStepImplementation } from '../steps/review-and-submit'

const createReceivedRequestStepRegistry = () => {
    const registry = createStepRegistry()

    registry.register(generalProductInformationStepImplementation)
    registry.register(generalProductInformationV2StepImplementation)
    registry.register(requestHandlingStepImplementation)
    registry.register(documentsAndWebpagesStepImplementation)
    registry.register(concernSubstanceListsStepImplementation)
    registry.register(productConcernSubstancesStepImplementation)
    registry.register(complianceInformationStepImplementation)
    registry.register(complianceInformationV2StepImplementation)
    registry.register(otherInformationStepImplementation)
    registry.register(declarationApprovalStepImplementation)
    registry.register(similarReplyRequestsStepImplementation)
    registry.register(sendReplyStepImplementation)
    registry.register(reviewAndSubmitStepImplementation)

    return registry
}

export { createReceivedRequestStepRegistry }
export default createReceivedRequestStepRegistry
